import { FC, useEffect, useState } from 'react'
import { NoteContainer, NoteTitle } from './styled'
import { handleLocalStorage } from '../../handleLocalStorage'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { Button } from 'featureSliced/entities/Button'
import { ButtonContainer } from 'featureSliced/entities/Button/styled'
import { ModalsSlice } from 'featureSliced/shared/store/reducers/ModalsReducer'
import { TextArea } from 'components/TextArea'

export type NotePropsType = {
  productId: number
  categoryId: number
  isUpdatesAvailable: boolean
  onUpdate?: (value: { [key: number]: string }) => void
}

export const Note: FC<NotePropsType> = ({
  productId,
  categoryId,
  onUpdate,
  isUpdatesAvailable,
}) => {
  const t = useTranslations()
  const dispatch = useMyDispatch()
  const { closeModal } = ModalsSlice.actions

  const [note, setNote] = useState('')

  useEffect(() => {
    getPrevValue()
  }, [categoryId, productId])

  const handleUpdateNote = (e: any) => {
    if (isUpdatesAvailable) {
      setNote(e.currentTarget.value)
    }
  }

  const getPrevValue = () => {
    const prevProductsNotes = handleLocalStorage('products_notes')
    setNote(prevProductsNotes?.[`${categoryId || 0}_${productId || 0}`] || '')
  }

  const updateProductNote = () => {
    const prevProductsNotes = handleLocalStorage('products_notes')
    handleLocalStorage({
      products_notes: {
        ...prevProductsNotes,
        [`${categoryId || 0}_${productId || 0}`]: note,
      },
    })
    if (onUpdate) {
      onUpdate({ ...prevProductsNotes, [`${categoryId}_${productId}`]: note })
    }
    dispatch(closeModal('PRODUCT_NOTE'))
  }

  return (
    <NoteContainer>
      <NoteTitle>{t('order.addNoteHeader')}</NoteTitle>
      <TextArea value={note} rows="10" onChange={handleUpdateNote} />
      <ButtonContainer>
        <Button
          buttonType="stroke"
          onClick={() => dispatch(closeModal('PRODUCT_NOTE'))}
        >
          {t('buttons.abort')}
        </Button>
        <Button buttonType="common" onClick={updateProductNote}>
          {t('buttons.save')}
        </Button>
      </ButtonContainer>
    </NoteContainer>
  )
}
